import { Box, Flex, MobileOnly, TabletUp, Text } from "@engaging-tech/components"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import SurveyIcon from "../../ui/components/SurveyIcon/SurveyIcon"
import ProgressBar from "../containers/ProgressBar"
import { useQuestionContext } from "../lib/QuestionContext"
import Answer from "./Answer/Answer"
import SurveyCard from "./SurveyCard"

const Question = ({
  currentQuestion,
  sectionTitle,
  question,
  questionCount,
  onNext,
  onPrevious,
  previousAnswer,
  onSubmit,
  questionId
}) => {
  const { isLastSection } = useQuestionContext()

  const [answer, setAnswer] = useState(previousAnswer)
  const { t } = useTranslation(["happiness_survey"])

  useEffect(() => {
    setAnswer(previousAnswer)
  }, [questionId, previousAnswer])

  if (!question || !question.type) {
    return null
  }

  const {
    title,
    description,
    type,
    fields,
    values,
    min,
    max,
    label,
    icon,
    required,
    allowOther,
    validation
  } = question
  const handleAnswer = value => {
    const answerValue = type === "checkbox" ? value : type === "short-text" ? value : [value]
    setAnswer({
      id: questionId,
      value: answerValue
    })
  }

  const validChecker = () => {
    if (type === "checkbox") {
      const isRequired = required === true || required === "true"

      if (!answer?.value) {
        if (!isRequired) {
          return true
        }
        return false
      }

      const checkboxValue = answer.value
      const selectedIds = checkboxValue?.values || (Array.isArray(checkboxValue) ? checkboxValue : [])
      const otherValues = checkboxValue?.otherValues || []
      const validOtherValues = otherValues.filter(ov => ov.value && ov.value.trim() !== "")
      const selectedCount = selectedIds.length + validOtherValues.length

      if (selectedCount === 0) {
        if (!isRequired) {
          return true
        }
        return false
      }

      if (!validation) {
        return true
      }

      if (validation.exact !== undefined && validation.exact !== null) {
        return selectedCount === validation.exact
      }

      if (validation.min !== undefined && validation.min !== null && selectedCount < validation.min) {
        return false
      }

      if (validation.max !== undefined && validation.max !== null && selectedCount > validation.max) {
        return false
      }

      return true
    }

    const isRequired = required === true || required === "true"

    if (!isRequired) {
      return true
    }

    if (!answer || !answer?.id) {
      return false
    }

    return true
  }

  const handleSubmit = () => {
    if (answer && validChecker()) {
      onSubmit(answer)
    }

    onNext()
  }

  return (
    <SurveyCard
      title={sectionTitle}
      isLast={currentQuestion === questionCount && isLastSection}
      onNext={handleSubmit}
      onPrevious={onPrevious}
      type={type}
      isValid={validChecker()}
    >
      <Flex>
        <TabletUp>
          <SurveyIcon name={icon} mr={3} />
        </TabletUp>
        <Box>
          <MobileOnly>
            <Flex mb={3} alignItems="flex-end">
              <SurveyIcon name={icon} mr={3} />
              <ProgressBar id={questionId} />
            </Flex>
          </MobileOnly>
          <TabletUp>
            <ProgressBar id={questionId} />
          </TabletUp>
          <Text fontWeight="500" color="dark.2" fontSize={[3, 4]}>
            {title}
          </Text>
          {!required && (
            <Text fontSize={3} color="dark.2">
              {" "}
              ({t("ui.optional", "")})
            </Text>
          )}
          <Answer
            type={type}
            fields={fields}
            values={values}
            description={description}
            min={min}
            max={max}
            label={label}
            allowOther={allowOther}
            validation={validation}
            onAnswer={value => handleAnswer(value)}
            initialValue={answer}
          />
        </Box>
      </Flex>
    </SurveyCard>
  )
}

export default Question
